const normalizeKeyPart = (value) => String(value || '').trim();

export const buildNotificationReconciliationKey = ({
  uid,
  municipioId,
  forceRefresh = false,
} = {}) => {
  const safeUid = normalizeKeyPart(uid);
  const safeMunicipioId = normalizeKeyPart(municipioId);
  if (!safeUid || !safeMunicipioId) return '';

  return JSON.stringify([
    safeUid,
    safeMunicipioId,
    forceRefresh ? 'force' : 'normal',
  ]);
};

export const createNotificationReconciliationDeduper = () => {
  const inFlight = new Map();

  const run = (key, operation) => {
    if (!key) {
      try {
        return Promise.resolve(operation());
      } catch (error) {
        return Promise.reject(error);
      }
    }

    const current = inFlight.get(key);
    if (current) return current;

    let promise;
    try {
      promise = Promise.resolve(operation());
    } catch (error) {
      promise = Promise.reject(error);
    }

    inFlight.set(key, promise);
    const clear = () => {
      if (inFlight.get(key) === promise) inFlight.delete(key);
    };
    promise.then(clear, clear);
    return promise;
  };

  return { run };
};
